import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logoSm from "../../assets/images/logo-sm.jpg";
import logoMd from "../../assets/images/logo-md.jpg";
import logoLg from "../../assets/images/logo-lg.jpg";

import flagEn from "../../assets/flags/en.webp";
import flagDe from "../../assets/flags/de.webp";
import flagFr from "../../assets/flags/fr.webp";

import { FiChevronDown } from "react-icons/fi";


import { useLanguage } from "../../context/LanguageContext";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const { lang, setLang, t } = useLanguage();
  const [langOpen, setLangOpen] = useState(false);

  return (
    <nav className="navbar-main">
      <div className="navbar-container">


        <div className="navbar-logo">
          <Link to="/">
            <div className="logo-holder-nav">
              <img
                src={logoSm}
                srcSet={`${logoSm} 120w, ${logoMd} 240w, ${logoLg} 360w`}
                sizes="80px"
                alt="Moni Échafaudage"
                className="logo-img"
                loading="eager"
              />
            </div>
            <span className="logo-text">{t.navbar.brand}</span>
          </Link>
        </div>


        <ul className="navbar-links">
          <li><a href="#about">{t.navbar.about}</a></li>
          <li><a href="#services">{t.navbar.services}</a></li>
          <li><a href="#gallery">{t.navbar.gallery}</a></li>
          <li><a href="#contact">{t.navbar.contact}</a></li>
        </ul>



        <div className="navbar-cta">
          <a href="#contact" className="btn-brand">
            {t.navbar.cta}
          </a>

          <div className="lang-dropdown">
            <button
              className={`lang-selected ${langOpen ? "open" : ""}`}
              onClick={() => setLangOpen(!langOpen)}
            >
              <div className="lang-selected-left">
                {lang === "en" && (
                  <>
                    <img src={flagEn} alt="English" className="lang-flag" />
                    <span>English</span>
                  </>
                )}

                {lang === "de" && (
                  <>
                    <img src={flagDe} alt="Deutsch" className="lang-flag" />
                    <span>Deutsch</span>
                  </>
                )}

                {lang === "fr" && (
                  <>
                    <img src={flagFr} alt="Français" className="lang-flag" />
                    <span>Français</span>
                  </>
                )}
              </div>

              <FiChevronDown className="lang-arrow" />
            </button>

            {langOpen && (
              <div className="lang-menu">
                <div onClick={() => { setLang("en"); setLangOpen(false); }}>
                  <img src={flagEn} alt="English" className="lang-flag" />
                  <span>English</span>
                </div>

                <div onClick={() => { setLang("de"); setLangOpen(false); }}>
                  <img src={flagDe} alt="Deutsch" className="lang-flag" />
                  <span>Deutsch</span>
                </div>

                <div onClick={() => { setLang("fr"); setLangOpen(false); }}>
                  <img src={flagFr} alt="Français" className="lang-flag" />
                  <span>Français</span>
                </div>
              </div>
            )}
          </div>
        </div>




        <div className="hamburger" onClick={() => setOpen(!open)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>


      <div className={`mobile-menu ${open ? "open" : ""}`}>
        <a href="#about" onClick={() => setOpen(false)}>
          {t.navbar.about}
        </a>
        <a href="#services" onClick={() => setOpen(false)}>
          {t.navbar.services}
        </a>
        <a href="#gallery" onClick={() => setOpen(false)}>
          {t.navbar.gallery}
        </a>
        <a href="#contact" onClick={() => setOpen(false)}>
          {t.navbar.contact}
        </a>

        {/* MOBILE LANGUAGE DROPDOWN */}
        <div className="mobile-lang-dropdown">
          <button
            className={`mobile-lang-selected ${langOpen ? "open" : ""}`}
            onClick={() => setLangOpen(!langOpen)}
          >
            <div className="mobile-lang-left">
              {lang === "en" && (
                <>
                  <img src={flagEn} alt="English" />
                  <span>English</span>
                </>
              )}
              {lang === "de" && (
                <>
                  <img src={flagDe} alt="Deutsch" />
                  <span>Deutsch</span>
                </>
              )}
              {lang === "fr" && (
                <>
                  <img src={flagFr} alt="Français" />
                  <span>Français</span>
                </>
              )}
            </div>

            <FiChevronDown className="mobile-lang-arrow" />
          </button>

          {langOpen && (
            <div className="mobile-lang-menu">
              <div
                onClick={() => {
                  setLang("en");
                  setLangOpen(false);
                  setOpen(false);
                }}
              >
                <img src={flagEn} alt="English" />
                <span>English</span>
              </div>

              <div
                onClick={() => {
                  setLang("de");
                  setLangOpen(false);
                  setOpen(false);
                }}
              >
                <img src={flagDe} alt="Deutsch" />
                <span>Deutsch</span>
              </div>

              <div
                onClick={() => {
                  setLang("fr");
                  setLangOpen(false);
                  setOpen(false);
                }}
              >
                <img src={flagFr} alt="Français" />
                <span>Français</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
